<template>
  <v-layout row wrap pa-3>
    <v-flex xs12 md8>
      <v-layout column main-section>
        <v-flex pt-3>
          <v-card-title>
            <h3 class="halfwhite-text">
              {{ $store.getters.getHeadingForBalanceBlock }}
            </h3>
            <h3 class="section-title halfwhite-text text-uppercase">
              Your Invitations
            </h3>
          </v-card-title>
          <MyInvites></MyInvites>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 md4 px-3>
      <v-layout column>
        <BalanceColumn></BalanceColumn>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import MyInvites from "@/views/InvitesFromOrganizations";
import BalanceColumn from "@/components/BalanceColumn";

export default {
  name: "MyInvitesView",
  components: { MyInvites, BalanceColumn },
};
</script>
